// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/strikethrough.js';

import { paths } from '../generated/strikethrough';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('strikethrough', Original, paths);
